import React from 'react';
import { makeStyles } from 'design-system';

const Timer = ({ waitSeconds }: { waitSeconds: number }) => {
  const classes = useStyles();

  return (
    <div className={classes.counterWrapper}>
      <span className={classes.loader}></span>
      <span className={classes.counter}>{waitSeconds}</span>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  loader: {
    border: '3px solid #ffffff' /* White */,
    borderTop: `3px solid ${theme.colors.green}` /* Greent */,
    borderRadius: '50%',
    width: 16,
    height: 16,
    animation: '$spin 1s linear infinite',
    '-webkit-animation': '$spin 1s linear infinite' /* Safari */,
    display: 'inline-flex',
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
  /* Safari */
  '@-webkit-keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },

  counterWrapper: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 5,
  },

  counter: {
    position: 'absolute',
    fontSize: '0.6rem',
  },
}));

export default Timer;
